import Box from "@/common/components/Box";
import { ShowHeader } from "@/common/components/ShowHeader";
import { useParams } from "react-router-dom";
import BankingDepositStatus from "../../components/BankingDepositStatus";
import BankingDepositResume from "../../components/BankingDepositResume";
import BankingDepositData from "../../components/BankingDepositData";
import PixInstructions from "../../components/PixInstructions";
import PixCopyAndPaste from "../../components/PixCopyAndPaste";
import { useEffect, useState } from "react";
import ConfettiOnPayment from "../../components/ConfettiOnPayment";
import useBankingDeposit from "../../hooks/useBankingDeposit";
import BankingDepositFiscalDocuments from "../../components/BankingDepositFiscalDocuments";
import { isAfter } from "date-fns";

const BankingDepositsShow = () => {
  const { id } = useParams();

  const [bankingDepositRefetchInterval, setBankingDepositRefetchInterval] = useState<number>();

  const {
    data: bankingDeposit,
    isPending: isBankingDepositPending,
  } = useBankingDeposit({
    id: id || '',
    refetchInterval: bankingDepositRefetchInterval,
  });

  const isExpiredDateBeforeNow = bankingDeposit?.payment?.source?.expires_at &&
    isAfter(new Date(bankingDeposit.payment.source.expires_at), new Date());
  const shouldDisplayPaymentSource = bankingDeposit?.status === "pending" && isExpiredDateBeforeNow;
  const isPaymentMethodPix = bankingDeposit?.payment?.source?.copy_and_paste;

  useEffect(() => {
    if (bankingDeposit?.status === "pending") {
      return setBankingDepositRefetchInterval(10 * 1000);
    }

    return setBankingDepositRefetchInterval(undefined);
  }, [bankingDeposit?.status]);

  return (
    <>
      <div>
        <ShowHeader
          goBack
          goBackProps={{ fallback: '/banking-deposits', searchLastRouteFromReference: `/banking-deposits/${id}` }}
          titleClassName="font-normal text-md text-white-400"
          title="Depósitos"
          subtitle="Detalhes do depósito"
        />

        <div className="flex flex-col gap-6">
          <BankingDepositData
            bankingDeposit={bankingDeposit}
            isLoading={isBankingDepositPending}
          />

          <Box className="flex gap-6 shadow-lg max-h-[calc(100vh-340px)] overflow-auto">
            <div className="flex flex-col gap-6 flex-1">
              <BankingDepositStatus
                status={bankingDeposit?.status}
                isLoading={isBankingDepositPending}
              />

              <BankingDepositResume
                bankingDeposit={bankingDeposit}
                isLoading={isBankingDepositPending}
              />

              {shouldDisplayPaymentSource && isPaymentMethodPix && (
                <PixInstructions />
              )}
            </div>

            {shouldDisplayPaymentSource && isPaymentMethodPix && (
              <PixCopyAndPaste
                bankingDeposit={bankingDeposit}
              />
            )}
          </Box>

          {bankingDeposit && <BankingDepositFiscalDocuments bankingDeposit={bankingDeposit} />}
        </div>
      </div>

      {bankingDeposit && <ConfettiOnPayment bankingDeposit={bankingDeposit} />}
    </>
  );
}

export default BankingDepositsShow;
